import { type ListVariant, listVariants } from "./constants";

type Props = {
	variant: ListVariant;
	children?: React.ReactNode;
};

const BulletList = ({ variant, children }: Props) => (
	<ul className={listVariants[variant]}>{children}</ul>
);

export default BulletList;
